import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));
export default function FSW_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [showMore, setShowMore] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const CustomExpandIcon = ({ isExpanded }) => (
    <span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
      {isExpanded ? "−" : "+"}
    </span>
  );

  return (
    <div className={classes.root} style={{ width: '85%', margin: '0 auto' }}>
      <Accordion
        className="py-2"
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel1"} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Introduction to Web Technologies 
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Learn about careers and job roles in web development, how websites work using client–server interaction, and the difference between web designers and developers. Understand static vs dynamic websites and the basics of responsive design.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel2"} />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
          HTML
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           Covers the basic structure of web pages, HTML elements, forms, lists, links, images, tables, special characters, and basic styling with backgrounds and classes.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel3"} />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
           CSS
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Focuses on styling web pages, including CSS syntax, selectors, colors, text, fonts, box model, lists, tables, and responsive design. Also introduces advanced CSS features and effects.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel4"} />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            JavaScript 
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Introduces interactivity with variables, operators, conditions, loops, functions, events, cookies, page redirection, and built-in objects for dynamic web behavior.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel5"} />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Advanced JavaScript
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Covers form validations for inputs, radio buttons, checkboxes, and select menus, along with DOM manipulation to dynamically update web content.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel6"} />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Version Control
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Learn the fundamentals of Git and GitHub, including basic commands, branching, merging, collaboration workflows, and integrating Git with front-end projects.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel7"} />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
           jQuery
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Simplifies JavaScript tasks with element selection, event handling, effects, and HTML manipulation using the jQuery library.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel8"}
        onChange={handleChange("panel8")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel8"} />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Bootstrap Framework
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Use Bootstrap to design responsive layouts, headers, navigation bars, banners, jumbotrons, rows, columns, and footers. Learn to style buttons, images, panels, and utilize utilities for polished web pages.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel9"}
        onChange={handleChange("panel9")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel9"} />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            DOM (Document Object Model)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Understand DOM structure, element selection, creating and modifying elements, setting attributes, and differentiating between innerHTML, innerText, appendChild, append, and query selectors.
          </Typography>
        </AccordionDetails>
      </Accordion>
<Accordion
        className="py-2"
        expanded={expanded === "panel10"}
        onChange={handleChange("panel10")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel10"} />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Asynchronous Programming
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
              Learn about callbacks, callback hell, promises, promise chaining, fetch API, and async/await. Implement CRUD operations in web applications using asynchronous JavaScript. 
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
  className="py-2"
  expanded={expanded === "panel11"}
  onChange={handleChange("panel11")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel11"} />}
    aria-controls="panel11bh-content"
    id="panel11bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      React
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Learn ES5 vs ES6, JSX, components, props, and state management. Build simple to reusable components, handle events, use hooks like useState and useEffect, manage component lifecycle, and deploy React apps to Netlify.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel12"}
  onChange={handleChange("panel12")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel12"} />}
    aria-controls="panel12bh-content"
    id="panel12bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      React Router & Context API
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
   Understand routing with react-router-dom, including BrowserRouter, Route, Link, and URL parameters. Use Context API to manage global state and avoid props drilling.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel13"}
  onChange={handleChange("panel13")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel13"} />}
    aria-controls="panel13bh-content"
    id="panel13bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      useRef, useReducer & Axios
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
    Learn advanced state management with useRef and useReducer. Implement front-end games like Hangman or Tic Tac Toe, work with APIs using Axios or fetch(), and perform CRUD operations.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel14"}
  onChange={handleChange("panel14")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel14"} />}
    aria-controls="panel14bh-content"
    id="panel14bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      React-Redux
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
     Introduction to Redux for state management in React applications, including actions, reducers, and connecting components to the Redux store.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel15"}
  onChange={handleChange("panel15")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel15"} />}
    aria-controls="panel15bh-content"
    id="panel15bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Database: MySQL
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
    Learn database fundamentals, basic queries, joins, DB model design, normalization, and select queries for structured data storage.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel16"}
  onChange={handleChange("panel16")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel16"} />}
    aria-controls="panel16bh-content"
    id="panel16bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Database: MongoDB
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
     Understand MongoDB, CRUD operations, aggregation, cursor methods, and the difference between server-side and client-side rendering.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel17"}
  onChange={handleChange("panel17")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel17"} />}
    aria-controls="panel17bh-content"
    id="panel17bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
     Node.js & Express.js
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
     Learn Node.js basics, npm packages, and connecting Node.js with MongoDB (local & Atlas). Work with Express.js for API development, request/response handling, and frontend-backend integration.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel18"}
  onChange={handleChange("panel18")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel18"} />}
    aria-controls="panel18bh-content"
    id="panel18bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Node.js Deployment & Authentication
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
     Deploy full-stack applications, implement authentication with bcrypt and JWT, use dotenv for environment variables, create custom middleware, and manage authorization between frontend and backend.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion
  className="py-2"
  expanded={expanded === "panel19"}
  onChange={handleChange("panel19")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel19"} />}
    aria-controls="panel19bh-content"
    id="panel19bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Minor & Major Projects
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Apply your learning by building a small React or Node.js project as a Minor Project and a full-stack dynamic web application with frontend, backend, and database integration as a Major Project to showcase real-world skills.
    </Typography>
  </AccordionDetails>
</Accordion>    
    {!showMore && (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowMore(true)}
            style={{
              fontWeight: "600",
              fontSize: "1rem",
              textTransform: "none",
              borderRadius: "8px",
            }}
          >
            + Show More
          </Button>
        </div>
      )}
      {/* ---- Skill Development Section ---- */}
      {showMore && (
        <div style={{ marginTop: "3rem" }}>
          <Typography
            variant="h5"
            style={{
              textAlign: "center",
              marginBottom: "0.5rem",
               fontWeight: "500",
              color: "#2b1c50",              
              fontSize: "2.5rem",
              userSelect: "none",              
            }}
          >
            Skill Development            
          </Typography>         
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              color: "var(--color-grey-darken-2)",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.9rem",
              maxWidth: "1000px",
              margin: "0 auto 2rem", 
              lineHeight: "1.8",
              userSelect: "none",
           }}
           >
          Boost your confidence, build job-ready skills, and get professional exposure with our practical, mentor-led sessions.
          </Typography>
          
          <Accordion expanded={expanded === "skill1"} onChange={handleChange("skill1")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill1"} />}
              aria-controls="skill1-content"
              id="skill1-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Ace Interviews
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
             <Typography>
             Master the art of first impressions! Understand professional dressing, confident body language, and effective communication to impress interviewers in both online and offline settings.           
          </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill2"} onChange={handleChange("skill2")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill2"} />}
              aria-controls="skill2-content"
              id="skill2-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Prepare Professionally
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Get ready like a pro! Know what documents to carry, how to handle online connectivity, and maintain etiquette throughout your interview process.
              </Typography>
            </AccordionDetails>
          </Accordion>
          
          <Accordion expanded={expanded === "skill3"} onChange={handleChange("skill3")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill3"} />}
              aria-controls="skill3-content"
              id="skill3-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Build an ATS-Optimized Resume
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Create a standout resume that passes recruiter screening. Learn about ATS keywords, structure, and impactful statements that highlight your achievements effectively.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill4"} onChange={handleChange("skill4")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill4"} />}
              aria-controls="skill4-content"
              id="skill4-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn How Recruiters Screen Resumes
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Get insider insights into how HRs and recruiters shortlist candidates. Understand what they look for and tailor your resume for better visibility.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill5"} onChange={handleChange("skill5")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill5"} />}
              aria-controls="skill5-content"
              id="skill5-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                 Learn LinkedIn Profile Optimization
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              Build a powerful LinkedIn profile that attracts recruiters. Learn how to grow your network, attempt skill assessments, and apply for relevant job or internship opportunities.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill6"} onChange={handleChange("skill6")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill6"} />}
              aria-controls="skill6-content"
              id="skill6-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                 Learn Post-Interview Strategies
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Know what to do after your interview — from handling feedback to understanding different interview types, consultancies, and HR connections for future opportunities.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill7"} onChange={handleChange("skill7")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill7"} />}
              aria-controls="skill7-content"
              id="skill7-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Workplace & Office Etiquette
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Step into the corporate world confidently! Learn workplace ethics, POSH guidelines, onboarding checks, and professional behavior to thrive in any environment.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill8"} onChange={handleChange("skill8")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill8"} />}
              aria-controls="skill8-content"
              id="skill8-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Effective Communication & Ethics
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Develop soft skills that matter — clear communication, gesture control, and maintaining professionalism in every conversation and meeting.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill9"} onChange={handleChange("skill9")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill9"} />}
              aria-controls="skill9-content"
              id="skill9-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Through Real HR Mock Interviews
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Gain hands-on experience with mock interview practice sessions conducted by real Talent Acquisition professionals.
                Get personalized feedback, understand real interview dynamics, and improve your confidence before stepping into actual interviews.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </div>
  );
}



